import React from 'react';
import banner from '../../../images/live_event.png';

const LiveExpBanner = () => {
  return (
    <div>
      <img src={banner} alt='' width='100%' height='100%' />
    </div>
  );
};
export default LiveExpBanner;
